import { useSelector } from "react-redux";
import { RingLoader } from "react-spinners";

const GlobalLoader = () => {

    const loading = useSelector(
        (state) => state.loaderReducer.loading
    );

    if (!loading) return null;

    return (
        <div style={overlayStyle}>
            <RingLoader size={60} color="#422c02" />
        </div>
    );
};

const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(255,255,255,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
};

export default GlobalLoader;
